export enum SnackBarStatus {
  INFO = 'info',
  WARNING = 'warning',
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
  ERROR = 'error',
}
